import React, { useCallback, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";

import BreadCrumb from "Components/Common/BreadCrumb";
import { normalize } from "common/lib/normalize";
import { getIndividual } from "common/services/individuals.service";
import { useParams } from "react-router-dom";
import Details from "./Details";
import Header from "./Header";
import Payments from "./Payments";

const ViewIndividual = () => {
  const { id: individualId } = useParams();

  const [data, setData] = useState<any>({});
  const [, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getIndividual(individualId, {});
      setData(normalize(response.data));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [individualId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Individual Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "Individuals", link: "/individuals" },
            ]}
            back
          />

          <Row>
            <Header individual={data} fetchData={fetchData} />
          </Row>
          <Row>
            <Details individual={data} />
            <Payments />
            {/* <Activity individual={data} /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewIndividual;
